import { render } from "./DialerCallRecords.vue?vue&type=template&id=9666ed98&scoped=true"
import script from "./DialerCallRecords.vue?vue&type=script&lang=js"
export * from "./DialerCallRecords.vue?vue&type=script&lang=js"

import "./DialerCallRecords.vue?vue&type=style&index=0&id=9666ed98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9666ed98"]])

export default __exports__